"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalisePath = exports.normaliseDomainName = exports.transformBranch = exports.createTNUMLookupGenerator = exports.createUrlLookupGenerator = exports.createEmailLookupGenerator = exports.createDomainLookupGenerator = exports.setenvDomainLookups = void 0;
var punycode_1 = __importDefault(require("punycode"));
var url_1 = require("url");
var exceptions_1 = require("./exceptions");
var hashutils_1 = require("./hashutils");
var numuri_1 = require("./numuri");
var num_easy_log_1 = require("num-easy-log");
var _NUM = '._num.';
var DNPREFIX = '_';
var TLZ = 'num.net';
var EMAIL_SEP = 'e';
var POP_3LZ = 'populator';
var DEFAULT_DEPTH = 3;
var WWW_REGEX = new RegExp(/^www\.\w+\.\w+/);
var SCHEME_REGEX = new RegExp(/^[a-zA-Z][0-9a-zA-Z+.-]+:/);
exports.setenvDomainLookups = function (env) {
    switch (env) {
        case 'test':
            TLZ = 'n001.uk';
            break;
        case 'staging':
            TLZ = 'n002.uk';
            break;
        case 'prod':
            TLZ = 'num.net';
            break;
        default:
            TLZ = 'num.net';
    }
};
exports.createDomainLookupGenerator = function (numUri) { return new DomainLookupGenerator(numUri); };
exports.createEmailLookupGenerator = function (numUri) { return new EmailLookupGeneratorImpl(numUri); };
exports.createUrlLookupGenerator = function (numUri) { return new UrlLookupGenerator(numUri); };
exports.createTNUMLookupGenerator = function (numUri) { return new TNUMLookupGenerator(numUri); };
var BaseLookupGenerator = (function () {
    function BaseLookupGenerator(numUri) {
        this._numUri = numUri;
        this._branch = '';
    }
    BaseLookupGenerator.prototype.getIndependentLocation = function (moduleId) {
        var result = this.getRootIndependentLocation(moduleId);
        return this.isDomainRoot() ? result : this._branch + "." + result;
    };
    BaseLookupGenerator.prototype.getHostedLocation = function (moduleId) {
        var result = this.getRootHostedLocation(moduleId);
        return this.isDomainRoot() ? result : this._branch + "." + result;
    };
    BaseLookupGenerator.prototype.isDomainRoot = function () {
        return this._branch === '';
    };
    BaseLookupGenerator.prototype.getPopulatorLocation = function (moduleId) {
        return this.isDomainRoot() ? moduleId.n + "." + DNPREFIX + this._numUri.host.s + "." + POP_3LZ + "." + TLZ + "." : null;
    };
    BaseLookupGenerator.prototype.getRootIndependentLocation = function (moduleId) {
        return "" + moduleId.n + _NUM + this._numUri.host.s + ".";
    };
    BaseLookupGenerator.prototype.getRootIndependentLocationNoModuleNumber = function (addTrailingDot) {
        if (addTrailingDot) {
            return "_num." + this._numUri.host.s + ".";
        }
        else {
            return "_num." + this._numUri.host.s;
        }
    };
    BaseLookupGenerator.prototype.getRootHostedLocation = function (moduleId) {
        return moduleId.n + "." + DNPREFIX + this._numUri.host.s + hashutils_1.hashByDepth(this._numUri.host.s, DEFAULT_DEPTH) + "." + TLZ + ".";
    };
    BaseLookupGenerator.prototype.getRootHostedLocationNoModuleNumber = function (addTrailingDot) {
        if (addTrailingDot) {
            return "" + DNPREFIX + this._numUri.host.s + hashutils_1.hashByDepth(this._numUri.host.s, DEFAULT_DEPTH) + "." + TLZ + ".";
        }
        else {
            return "" + DNPREFIX + this._numUri.host.s + hashutils_1.hashByDepth(this._numUri.host.s, DEFAULT_DEPTH) + "." + TLZ;
        }
    };
    BaseLookupGenerator.prototype.validate = function (numId, moduleId) {
        throw new Error("Not implemented: valdate(" + numId + ", " + moduleId + ")");
    };
    return BaseLookupGenerator;
}());
exports.transformBranch = function (s) {
    if (s === '/') {
        return '';
    }
    var i = s.indexOf('/');
    return s
        .substring(i + 1)
        .split('/')
        .reverse()
        .join('.');
};
exports.normaliseDomainName = function (domainName) {
    if (!domainName) {
        throw new exceptions_1.NumInvalidParameterException('Null domain name cannot be normalised');
    }
    if (domainName.trim() === '') {
        throw new exceptions_1.NumInvalidParameterException('Empty domain name cannot be normalised');
    }
    if (SCHEME_REGEX.test(domainName)) {
        try {
            var host = new url_1.URL(domainName).hostname;
            return exports.normaliseDomainName(host);
        }
        catch (e) {
            if (e instanceof exceptions_1.NumException) {
                throw e;
            }
            else {
                throw new exceptions_1.NumBadUrlException("Invalid URL: " + domainName, e);
            }
        }
    }
    var result = domainName;
    if (WWW_REGEX.test(result)) {
        result = result.substring(4);
    }
    if (result.startsWith('.')) {
        result = result.substring(1);
    }
    if (result.endsWith('.')) {
        result = result.substring(0, result.length - 1);
    }
    result = punycode_1.default.toASCII(result);
    return result;
};
exports.normalisePath = function (path) {
    var result = '/';
    if (path.length > 0) {
        var pathComponents = path.split('/');
        var nonEmptyPathComponents = pathComponents.filter(function (s) { return s && s.length > 0; });
        if (nonEmptyPathComponents.length > 0 && nonEmptyPathComponents[nonEmptyPathComponents.length - 1].includes('.')) {
            nonEmptyPathComponents.pop();
        }
        if (nonEmptyPathComponents.length > 0) {
            result += nonEmptyPathComponents.join('/').split(' ').join('_');
        }
    }
    return result;
};
var DomainLookupGenerator = (function (_super) {
    __extends(DomainLookupGenerator, _super);
    function DomainLookupGenerator(numUri) {
        var _this = _super.call(this, numUri) || this;
        var branch = exports.transformBranch(exports.normalisePath(numUri.path.s));
        _this._branch = branch !== '' ? punycode_1.default.toASCII(branch) : branch;
        if (_this._branch !== branch) {
            num_easy_log_1.log.debug("Query " + _this._branch + " punycode " + branch);
        }
        _this._numUri = _this._numUri.withHost(new numuri_1.Hostname(exports.normaliseDomainName(numUri.host.s)));
        return _this;
    }
    return DomainLookupGenerator;
}(BaseLookupGenerator));
var EmailLookupGeneratorImpl = (function (_super) {
    __extends(EmailLookupGeneratorImpl, _super);
    function EmailLookupGeneratorImpl(numUri) {
        var _this = _super.call(this, numUri) || this;
        var localPart = _this._numUri.userinfo;
        var newUserinfo = localPart !== numuri_1.NO_USER_INFO ? punycode_1.default.toASCII(localPart.s) : localPart.s;
        _this._numUri = _this._numUri.withUserinfo(new numuri_1.UrlUserInfo(newUserinfo));
        _this._numUri = _this._numUri.withHost(new numuri_1.Hostname(exports.normaliseDomainName(numUri.host.s)));
        var branch = exports.transformBranch(exports.normalisePath(numUri.path.s));
        _this._branch = branch !== '' ? punycode_1.default.toASCII(branch) : branch;
        if (branch !== _this._branch) {
            num_easy_log_1.log.debug("Query " + branch + " punycode " + _this._branch);
        }
        return _this;
    }
    Object.defineProperty(EmailLookupGeneratorImpl.prototype, "localPart", {
        get: function () {
            return this._numUri.userinfo.s;
        },
        enumerable: false,
        configurable: true
    });
    EmailLookupGeneratorImpl.prototype.getIndependentLocation = function (moduleId) {
        var result = this.getRootIndependentLocation(moduleId);
        return this.isDomainRoot() ? result : this._branch + "." + result;
    };
    EmailLookupGeneratorImpl.prototype.getHostedLocation = function (moduleId) {
        var result = this.getRootHostedLocation(moduleId);
        return this.isDomainRoot() ? result : this._branch + "." + result;
    };
    EmailLookupGeneratorImpl.prototype.getPopulatorLocation = function (moduleId) {
        num_easy_log_1.log.warn("getPopulatorLocation called on email with " + moduleId.n);
        return null;
    };
    EmailLookupGeneratorImpl.prototype.getRootIndependentLocation = function (moduleId) {
        return moduleId.n + "." + DNPREFIX + this.localPart + "." + EMAIL_SEP + _NUM + this._numUri.host.s + ".";
    };
    EmailLookupGeneratorImpl.prototype.getRootIndependentLocationNoModuleNumber = function (addTrailingDot) {
        if (addTrailingDot) {
            return "" + DNPREFIX + this.localPart + "." + EMAIL_SEP + _NUM + this._numUri.host.s + ".";
        }
        else {
            return "" + DNPREFIX + this.localPart + "." + EMAIL_SEP + _NUM + this._numUri.host.s;
        }
    };
    EmailLookupGeneratorImpl.prototype.getRootHostedLocation = function (moduleId) {
        return moduleId.n + "." + DNPREFIX + this.localPart + "." + EMAIL_SEP + "." + DNPREFIX + this._numUri.host.s + hashutils_1.hashByDepth(this._numUri.host.s, DEFAULT_DEPTH) + "." + TLZ + ".";
    };
    EmailLookupGeneratorImpl.prototype.getRootHostedLocationNoModuleNumber = function (addTrailingDot) {
        if (addTrailingDot) {
            return "" + DNPREFIX + this.localPart + "." + EMAIL_SEP + "." + DNPREFIX + this._numUri.host.s + hashutils_1.hashByDepth(this._numUri.host.s, DEFAULT_DEPTH) + "." + TLZ + ".";
        }
        else {
            return "" + DNPREFIX + this.localPart + "." + EMAIL_SEP + "." + DNPREFIX + this._numUri.host.s + hashutils_1.hashByDepth(this._numUri.host.s, DEFAULT_DEPTH) + "." + TLZ;
        }
    };
    EmailLookupGeneratorImpl.prototype.getDistributedIndependentLocation = function (moduleId, levels) {
        var emailLocalPartHash = hashutils_1.hashByDepth(this._numUri.userinfo.s, levels.n);
        var result = moduleId.n + "." + DNPREFIX + this.localPart + emailLocalPartHash + "." + EMAIL_SEP + _NUM + this._numUri.host.s + ".";
        return this.isDomainRoot() ? result : this._branch + "." + result;
    };
    EmailLookupGeneratorImpl.prototype.getDistributedHostedLocation = function (moduleId, levels) {
        var emailLocalPartHash = hashutils_1.hashByDepth(this._numUri.userinfo.s, levels.n);
        var result = moduleId.n + "." + DNPREFIX + this.localPart + emailLocalPartHash + "." + EMAIL_SEP + "." + DNPREFIX + this._numUri.host.s + hashutils_1.hashByDepth(this._numUri.host.s, DEFAULT_DEPTH) + "." + TLZ + ".";
        return this.isDomainRoot() ? result : this._branch + "." + result;
    };
    return EmailLookupGeneratorImpl;
}(BaseLookupGenerator));
var UrlLookupGenerator = (function (_super) {
    __extends(UrlLookupGenerator, _super);
    function UrlLookupGenerator(numUri) {
        var _this = _super.call(this, numUri) || this;
        _this._numUri = _this._numUri.withHost(new numuri_1.Hostname(exports.normaliseDomainName(numUri.host.s)));
        var branch = exports.transformBranch(exports.normalisePath(numUri.path.s));
        _this._branch = branch !== '' ? punycode_1.default.toASCII(branch) : branch;
        if (branch !== _this._branch) {
            num_easy_log_1.log.debug("Query " + branch + " punycode " + _this._branch);
        }
        return _this;
    }
    return UrlLookupGenerator;
}(BaseLookupGenerator));
var NO_COUNTRY_CODE_MSG = 'No Country code defined for ';
var TNUMLookupGenerator = (function (_super) {
    __extends(TNUMLookupGenerator, _super);
    function TNUMLookupGenerator(numUri) {
        var _this = _super.call(this, numUri) || this;
        var branch = exports.transformBranch(exports.normalisePath(numUri.path.s));
        _this._branch = branch !== '' ? punycode_1.default.toASCII(branch) : branch;
        if (_this._branch !== branch) {
            num_easy_log_1.log.debug("Query " + _this._branch + " punycode " + branch);
        }
        _this._numUri = _this._numUri.withHost(new numuri_1.Hostname(exports.normaliseDomainName(numUri.host.s)));
        if (!numuri_1.Hostname.isValidTNUM(_this._numUri.host.s)) {
            throw new exceptions_1.NumInvalidParameterException('Domain name is invalid for TNUM');
        }
        return _this;
    }
    TNUMLookupGenerator.prototype.getPopulatorLocation = function (_moduleNumber) {
        return null;
    };
    TNUMLookupGenerator.prototype.getIndependentLocation = function (moduleNumber) {
        var result = this.getRootIndependentLocation(moduleNumber);
        if (this._branch.length > 0) {
            return this._branch + '.' + result;
        }
        return result;
    };
    TNUMLookupGenerator.prototype.getHostedLocation = function (moduleNumber) {
        var result = this.getRootHostedLocation(moduleNumber);
        if (this._branch.length > 0) {
            return this._branch + '.' + result;
        }
        return result;
    };
    TNUMLookupGenerator.prototype.getRootIndependentLocation = function (moduleNumber) {
        var countryCode = this.findCountryCode(this._numUri.host.s);
        if (!countryCode) {
            throw new exceptions_1.NumInvalidParameterException(NO_COUNTRY_CODE_MSG + this._numUri.host.s);
        }
        return "" + moduleNumber.n + _NUM + this.formatIndependentTNumDomain(countryCode, this._numUri.host.s) + "." + countryCode.dnsRoot + ".";
    };
    TNUMLookupGenerator.prototype.getRootHostedLocation = function (moduleNumber) {
        var countryCode = this.findCountryCode(this._numUri.host.s);
        if (!countryCode) {
            throw new exceptions_1.NumInvalidParameterException(NO_COUNTRY_CODE_MSG + this._numUri.host.s);
        }
        if (MappingPattern.sds === countryCode.mappingPattern) {
            return moduleNumber.n + "." + DNPREFIX + this.formatHostedTNumDomain(countryCode, this._numUri.host.s) + "." + countryCode.dnsRoot + ".";
        }
        else {
            return moduleNumber.n + "." + DNPREFIX + this.formatHostedTNumDomain(countryCode, this._numUri.host.s) + "._t." + TLZ + ".";
        }
    };
    TNUMLookupGenerator.prototype.getRootIndependentLocationNoModuleNumber = function (addTrailingDot) {
        var countryCode = this.findCountryCode(this._numUri.host.s);
        if (!countryCode) {
            throw new exceptions_1.NumInvalidParameterException(NO_COUNTRY_CODE_MSG + this._numUri.host.s);
        }
        var result = "_num." + this.formatIndependentTNumDomain(countryCode, this._numUri.host.s) + "." + countryCode.dnsRoot;
        if (addTrailingDot) {
            return result + '.';
        }
        return result;
    };
    TNUMLookupGenerator.prototype.getRootHostedLocationNoModuleNumber = function (addTrailingDot) {
        var result = this.getRootHostedLocation(numuri_1.MODULE_0).substr(2);
        if (addTrailingDot) {
            return result;
        }
        return result.substr(0, result.length - 1);
    };
    TNUMLookupGenerator.prototype.formatIndependentTNumDomain = function (code, domain) {
        var noIntlPrefix = domain.substr(code.code.length);
        var result = '';
        switch (code.mappingPattern) {
            case MappingPattern.bds:
                result = this.mapBDS(noIntlPrefix);
                result = reverse(result);
                break;
            case MappingPattern.sds:
                result = this.mapSDS(noIntlPrefix);
                break;
            default:
                throw new exceptions_1.NumInvalidParameterException("Bad enum value: " + code.mappingPattern);
        }
        return result;
    };
    TNUMLookupGenerator.prototype.formatHostedTNumDomain = function (code, domain) {
        var noIntlPrefix = domain.substr(code.code.length);
        var result = '';
        switch (code.mappingPattern) {
            case MappingPattern.bds:
                result = this.mapBDS(noIntlPrefix);
                result = reverse(result) + '.' + reverse(code.code.substr(1));
                break;
            case MappingPattern.sds:
                result = this.mapSDS(noIntlPrefix);
                break;
            default:
                throw new exceptions_1.NumInvalidParameterException("Bad enum value: " + code.mappingPattern);
        }
        return result;
    };
    TNUMLookupGenerator.prototype.mapBDS = function (noIntlPrefix) {
        var result = '';
        var count = 0;
        var threes = 1;
        var insertions = 0;
        while (count < noIntlPrefix.length) {
            result += noIntlPrefix.charAt(count);
            if (threes % 3 === 0 && insertions < 2) {
                result += '.';
                insertions++;
            }
            count++;
            threes++;
        }
        return result;
    };
    TNUMLookupGenerator.prototype.mapSDS = function (noIntlPrefix) {
        return this.intersperseDots(reverse(noIntlPrefix));
    };
    TNUMLookupGenerator.prototype.intersperseDots = function (s) {
        return s.split('').join('.');
    };
    TNUMLookupGenerator.prototype.findCountryCode = function (domain) {
        return codes.find(function (cc) { return domain.startsWith(cc.code); });
    };
    return TNUMLookupGenerator;
}(BaseLookupGenerator));
var reverse = function (s) { return s.split('').reverse().join(''); };
var CountryCode = (function () {
    function CountryCode(code, mappingPattern, dnsRoot) {
        this.code = code;
        this.mappingPattern = mappingPattern;
        this.dnsRoot = dnsRoot;
    }
    return CountryCode;
}());
var MappingPattern;
(function (MappingPattern) {
    MappingPattern[MappingPattern["bds"] = 0] = "bds";
    MappingPattern[MappingPattern["sds"] = 1] = "sds";
})(MappingPattern || (MappingPattern = {}));
var codes = [
    new CountryCode('+9999', MappingPattern.sds, '9.9.9.9.e164.arpa'),
    new CountryCode('+44', MappingPattern.bds, '44.tnum.net'),
    new CountryCode('+1', MappingPattern.bds, '44.tnum.net'),
];
//# sourceMappingURL=lookupgenerators.js.map